import { AuthForm } from '@/components/auth/auth-form'

export default function SignUpPage() {
  return (
    <div className="flex flex-1 w-full items-center justify-center px-4 py-8">
      <div className="w-full max-w-[350px]">
        <AuthForm mode="signup" />
      </div>
    </div>
  )
}
